export var getCarouselProps = function getCarouselProps(layoutType) {
  switch (layoutType) {
    case 'tablet':
    case 'mobile':
      return {
        itemMinWidth: 270,
        maxItemsPerPage: 1
      };
    case 'desktop':
    case 'desktopSmall':
    default:
      return {
        itemMinWidth: 320,
        maxItemsPerPage: 2
      };
  }
};